import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { projectsApi } from '../../../../../utils';
import Project from '../../Project'
import backIcon from '../../../assests/back.png'
import classes from './ProjectLibraryPopup.module.css'
import { useParams } from 'react-router-dom';
import { ObjectTypeEnumText } from '../../../models/ObjectTypeEnum';

const ProjectLibraryPopup = ({ setNewPost, close, chooseProject }) => {

    const texts = useSelector(state => state.translate.texts);
    const [allProjects, setAllProjects] = useState()
    const [ChooseProjects, setChooseProjects] = useState({})
    const { studyGroupId } = useParams()

    useEffect(() => {
        const data = {
            onlyDrafts: true,
            refObjectId: studyGroupId,
            refObjectType: ObjectTypeEnumText.StudyGroup,
            includeIsShared: true
        }

        projectsApi.projectsFilterRangePost({ projectsRangeFilter: data }, (error, resdata, response) => {
            if (!error) {
                setAllProjects(resdata.filter(p => p.isShared === false))
            }
        })
    }, [])

    function closePopup() {
        close && close()
    }

    function chooseProjectFunc() {
        chooseProject(Object.values(ChooseProjects)[0])
        close && close()
    }

    function addProjectToList(p) {
        setChooseProjects(p)
        setNewPost && setNewPost()
    }

    return (
        <div className={classes.ProjectLibraryPopupContainer}>
            <div className={classes.ProjectLibraryPopup}>
                <div className={classes.LibraryPopup}>
                    <div className={classes.Circle} onClick={(e) => closePopup(e)}>
                        <div className={classes.XLine}></div>
                        <div className={`${classes.XLine} ${classes.Rotate}`}></div>
                    </div>
                    <div className={classes.TitleWithBackIcon}>
                        <img className={classes.Back} src={backIcon} onClick={(e) => closePopup(e)} alt="back" />
                        <div className={classes.Title}>{texts.chooseProjectToShare}</div>
                    </div>
                    {allProjects ? allProjects.length > 0 ?
                        <>
                            <div className={classes.ChooseBtn} onClick={chooseProjectFunc}>{texts.choose}</div>
                            <div className={classes.Overflow}>
                                <div className={classes.allProjects}>
                                    {allProjects.map((p, i) =>
                                        <div className={`${classes.Project} ${Object.keys(ChooseProjects).includes(String(i)) ? classes.ChooseProject : ''}`} onClick={() => addProjectToList({ [i]: p })} key={i}>
                                            <Project
                                                project={p}
                                                descriptionDate={moment(p.createdDate).format('DD/MM/YY')}
                                                noEditName={true}
                                                oldProject={false} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                        : <div className={classes.NoProjects}>{texts.noProjects}</div>
                        : <div className={classes.NoProjects}>{texts.dataLoading}</div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ProjectLibraryPopup;